import { Action, Col, Row } from '@op/opds.opux';
import styles from './QnaBuyerSupport.module.scss';
import i18n from 'i18n';

interface Props {
  readonly renderBorderTop?: boolean;
}

const QnaBuyerSupport = ({ renderBorderTop }: Props) => {
  return (
    <Row
      className={renderBorderTop ? styles.qnaBorderTop : ''}
      data-testid='qna-buyer-support-component'>
      <Col className={styles.qnaContent}>
        <h2 className={styles.qnaTitle}>{i18n.t('qna.title')}</h2>
        <p className={styles.qnaBody}>{i18n.t('qna.body')}</p>
        <Action
          external
          href={i18n.t(
            'link.onlineBuyerHelp.ONLINE_BUYER_HELP_CUSTOMER_SERVICE_URL'
          )}
          className={styles.qnaLink}>
          {i18n.t('link.onlineBuyerHelp.text')}
        </Action>
      </Col>
    </Row>
  );
};

export default QnaBuyerSupport;
